package com.imobly.imobly.api.dto

class Ok: ResponseMessage()